import Vue from 'vue'

export default ({ app }, inject) => {
  inject('var', Vue.observable({
    TMN: 'TMN',
    USDT: 'USDT',
    coin: 'coin',
    sideBuy: 'BUY',
    sideSell: 'SELL',
    popular: 'popular',
    new: 'new',
    related: 'related',
    selected: 'selected',
    all: 'all',
    trends: 'trends',
    topGain: 'topGain'
  }))
}
